import { formatShiftLabel, type EventShift } from '@/utils/eventShifts';

/**
 * The event's time line. Shifts win; events from before shifts existed still carry their
 * free-text `time_intervals`, which are shown as they were.
 */
export function formatEventTimes(shifts: EventShift[], legacyIntervals: string[] | undefined): string {
  if (shifts.length === 1) return formatShiftLabel(shifts[0]);
  if (shifts.length > 1) return `${shifts.length} shifts`;
  if (!legacyIntervals || legacyIntervals.length === 0) return 'Time not specified';
  return legacyIntervals.join(', ');
}

/**
 * Whether to show the "Your shifts" block (Change shift / Leave).
 *
 * It follows the shifts' own `mine` flag, which comes from the database, rather than the
 * page's idea of whether you are viewing as a volunteer. Those disagree for someone who is
 * both an admin of an organization and a volunteer on the event: in admin mode the preview
 * skips its volunteer lookup, so the volunteer card is hidden -- yet the shift list still
 * tags their shift YOU. Gating on the volunteer flag hid the buttons in exactly that case.
 * Leaving and changing are checked against the caller's own membership server-side, so
 * offering them here is safe in either mode.
 *
 * Accepted volunteers who are on no shift still see the block, for its empty state.
 */
export function showsYourShifts(input: {
  shifts: EventShift[];
  loading: boolean;
  isEventEnded: boolean;
  isAcceptedVolunteer: boolean;
  isOrgView: boolean;
}): boolean {
  if (input.loading || input.isEventEnded || input.shifts.length === 0) return false;
  return input.shifts.some((s) => s.mine) || (input.isAcceptedVolunteer && !input.isOrgView);
}

export function formatDepartments(departments: string[] | undefined): string {
  if (!departments || departments.length === 0) return 'No departments specified';
  return departments.join(', ');
}
